export default "__VITE_ASSET__Dz7yvw1X__"